const mci = [
    "0990",
    "0991",
    "0992",
    "0910",
    "0911",
    "0912",
    "0913",
    "0914",
    "0915",
    "0916",
    "0917",
    "0918",
    "0919",
    "0993",
    "0994",
]
const mtn = [
    "0901",
    "0902",
    "0903",
    "0904",
    "0905",
    "0930",
    "0932",
    "0933",
    "0935",
    "0936",
    "0937",
    "0938",
    "0939",
    "0941",
    '0900'
]
const righte = [
    "0920",
    "0921",
    "0922"
]

// const samantel = [
//     "0999"
// ]

// const talia = [
//     "0932"
// ]


export const opratorSelector = (AllNum: string) => {
    if (AllNum?.length >= 4) {
        let num = AllNum.slice(0, 4)
        const mtnCheck = mtn.includes(num)
        const mciCheck = mci.includes(num)
        const righteCheck = righte.includes(num)
        if (mtnCheck) {
            return 1
        } else if (mciCheck) {
            return 2
        } else if (righteCheck) {
            return 3
        }
    }
}